import formatTableJson from '@manage/config/tableComponentParams.js'
export default formatTableJson([
  {
    filed: 'admin',
    label: '操作人'
  },
  {
    filed: 'operation',
    label: '操作描述'
  },
  {
    filed: 'operationType',
    label: '操作类型',
    formatFn: function (_, row) {
      let dic = {
        1: '登录',
        2: '新增',
        3: '修改',
        4: '删除',
        5: '导入',
        6: '其他'
      }
      return dic[row.operationType]
    }
  },
  {
    filed: 'moduleName',
    label: '操作模块'
  },
  {
    filed: 'ip',
    label: '用户IP'
  },
  {
    filed: 'createTime',
    label: '操作时间',
    type: 'time',
    width: '170'
  }
])
